import { theme, ThemePaths } from "../../theme";
import getREMFromPX from "../../utils/getREMFromPX";

export const getIconStyle = (themePath: ThemePaths = "default") => ({
  width: getREMFromPX(theme.spacing * 20),
  height: getREMFromPX(theme.spacing * 20),
  color: theme[themePath].colors.stepper.secondaryIconFill,
  marginBottom: getREMFromPX(theme.spacing * 4),
});
